import React, { Component } from 'react';

import { StringUtils, DateUtils } from '../utils';
import { Button, AppointmentIcon, Header, Line } from '../components';
import { History as history, Routes as routes } from '../navigation';
import '../css/SignIn.css';

class AppointmentsList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      displayCount: 5,
    }
  }

  renderLine = (display_line) => {
    if (display_line) {
      return <div style={{ height: 1, backgroundColor: '#e7e7e7', marginTop: 15, marginBottom: 15 }}></div>
    }
  }

  renderStatusSelectionButton = (status) => {
    let current_status  = this.props.currentFilter || 'UPCOMING';
    let title = 'Active';
        title = status === 'UPCOMING'  ? 'Upcoming'  : title;
        title = status === 'COMPLETED' ? 'Completed' : title;
        title = status === 'CANCELLED' ? 'Cancelled' : title;

    let header_title = title + ' Appointments';

    let selected = status === current_status ? true : false;
    let color    = selected ? '#1dc2ff' : 'white';
    let txt_clr  = selected ? '#1dc2ff' : '';
    let filter_change_action = this.props.onFilterChange ? this.props.onFilterChange : (status) => {  };
    return <div className='selected-consultation-type-header flex-container-column'
                style={{ justifyContent: 'space-between', alignItems: 'center', height: 45 }}
                onClick={ () => { this.props.onFilterChange(status) }}>
      <div></div>
      <span className='flex-container-row' style={{ alignItems: 'center', fontSize: 15, marginRight: 20, marginLeft: 20, color: txt_clr }}>
        { title }
      </span>
      <div style={{ height: 2, backgroundColor: color, width: '100%'}}></div>
    </div>
  }

  renderLabelRow = () => {
    return <div className='flex-container-column'>
      <div className='flex-container-row' style={{ paddingTop: 3, paddingBottom: 3 }}>
        <div style={{ width: '30%', color: '#1dc2ff', fontSize: 11, fontWeight: 'bold', paddingLeft: 15 }}>DATE & TIME</div>
        <div style={{ width: '25%', color: '#1dc2ff', fontSize: 11, fontWeight: 'bold' }}>PROVIDER</div>
        <div style={{ width: '25%', color: '#1dc2ff', fontSize: 11, fontWeight: 'bold' }}>CLIENT</div>
        <div style={{ width: '20%', color: '#1dc2ff', fontSize: 11, fontWeight: 'bold' }}>{ 'STATUS' }</div>
      </div>
      <Line />
    </div>
  }

  renderStatusLabel = (status) => {
    let label_text = status === 'UPCOMING'  ? 'Upcoming' : '';
        label_text = status === 'COMPLETED' ? 'Completed': label_text;
        label_text = status === 'CANCELLED' ? 'Cancelled': label_text;
    let icon_class = status === 'UPCOMING'  ? 'fas fa-clock' : 'fas fa-clock';
        icon_class = status === 'COMPLETED' ? 'fas fa-check' : icon_class;
        icon_class = status === 'CANCELLED' ? 'fas fa-times' : icon_class;
    let bg_color   = status === 'UPCOMING'  ? '#e8f8ff' : '#e8f8ff';
        bg_color   = status === 'COMPLETED' ? '#e0f6e2' : bg_color;
        bg_color   = status === 'CANCELLED' ? '#fee7ea' : bg_color;
    let color      = status === 'UPCOMING'  ? '#1dc2ff' : '#1dc2ff';
        color      = status === 'COMPLETED' ? '#66D56F' : color;
        color      = status === 'CANCELLED' ? '#F71735' : color;

    return <div className='flex-container-column' style={{ alignItems: 'flex-start' }}>
    <span className='flex-container-row' style={{ borderRadius: 15, padding: 3, paddingRight: 11, paddingLeft: 11, alignItems: 'center', color: color, backgroundColor: bg_color }}>
      <span className={icon_class} style={{ fontSize: 11, marginBottom: 2 }}></span>
      <span style={{ fontWeight: 'bold', fontSize: 11, marginLeft: 5, marginRight: 5 }}>{ label_text }</span>
    </span>
    </div>
  }

  renderAppointments = (appointment_ids) => {

    let appointment_dict   = this.props.appointments || {};

    if (!appointment_ids) {
      return null
    }

    let only_display_upcoming = this.props.displayOnlyUpcoming === true ? true : false;
    let display_limit         = this.props.displayLimit;

    let appointments = appointment_ids.map((appointment_id) => {
      let appointment = appointment_dict[appointment_id] || null;
      if (appointment && (!only_display_upcoming || (only_display_upcoming && appointment.status === 'UPCOMING'))) {
        return appointment;
      }
    }).filter((apt) => { return apt }).sort((a, b) => { return new Date(a.time) - new Date(b.time) });

    let appointment_rows = appointments.map((appointment, index) => {

      if (display_limit && index >= display_limit) {
        return null;
      }

      let apt_month = appointment.time && DateUtils.getShortMonth(appointment.time) ? DateUtils.getShortMonth(appointment.time) : 'Jan';
      let apt_date  = appointment.time && DateUtils.getDateNumber(appointment.time) ? DateUtils.getDateNumber(appointment.time) : '00';
      let hour      = appointment.time ?  DateUtils.getHoursString(appointment.time)   : '00';
      let minutes   = appointment.time ?  DateUtils.getMinutesString(appointment.time) : '00';
      let ampm      = appointment.time ?  DateUtils.getAMPMString(appointment.time)    : 'AM';
      let day       = appointment.time ?  DateUtils.getLongWeekday(appointment.time)   : 'Weekday';

      let participant_info  = this.getParticipantInfo(appointment);
      let is_last_row       = appointments.length - 1 === index || display_limit && index === display_limit - 1;
      let status_color      = appointment.status === 'CANCELLED' ? 'red' : '#66D56F';
      let date_time_string  = apt_month + ' ' + apt_date + ' | ' + hour + ':' + minutes + ' ' + ampm;

      return <div key={appointment._id} className='flex-container-column'
                  onClick={ () => {
                    let consultation = this.getConsultation(appointment);
                    if (consultation) {
                      this.props.consultationsActions.openConsultation(this.props.token, consultation);
                    }
                  }}>
        <div className='flex-container-row standard-selection-row' style={{ paddingTop: 10, paddingBottom: 10, alignItems: 'center' }}>
          <div style={{ width: '30%', color: 'grey', fontSize: 13, paddingLeft: 15 }}>{ date_time_string }</div>
          <div style={{ width: '25%', color: 'grey', fontSize: 13 }}>{ participant_info.provider }</div>
          <div style={{ width: '25%', color: 'grey', fontSize: 13 }}>{ participant_info.client }</div>
          <div style={{ width: '20%', color: 'grey', fontSize: 13 }}>{ this.renderStatusLabel(appointment.status) }</div>
        </div>
        <Line style={{ backgroundColor: '#f5f5f5' }} />
      </div>
    }).filter((row) => { return row });

    let current_filter  = this.props.currentFilter || 'UPCOMING';
    let display_no_apts = appointment_rows.length === 0 ? true : false;
    let no_apts_message = 'There are no ' + StringUtils.sentenceCase(current_filter.toLowerCase())  + ' appointments.';
        no_apts_message = current_filter === 'UPCOMING' ? 'You have no upcoming appointments.' : no_apts_message;
    let display_filters = this.props.displayFilters === true ? true : false;

    return <div className="standard-container">

      { this.renderTitle()   }
      { display_filters ? <div className='flex-container-row'>
                            { this.renderStatusSelectionButton('UPCOMING') }
                            { this.renderStatusSelectionButton('COMPLETED') }
                            { this.renderStatusSelectionButton('CANCELLED') }
                          </div>   : null }
      { display_filters ? <Line /> : null }
      { this.renderLabelRow()  }
      <div className='flex-container-column'>
        { display_no_apts ? null : appointment_rows }
        { display_no_apts ? <span style={{ alignSelf: 'center', color: 'grey', fontSize: 14, marginBottom: 40, marginTop: 40 }}>{ no_apts_message }</span> : null }
      </div>
    </div>
  }

  renderTitle = () => {
    let hide_title = this.props.hideTitle === true ? true : false;
    let title        = this.props.title || 'Appointments';

    if (hide_title) {
      return null;
    }

    return <Header title={title}
                   icon={'fa-calendar-check'}
                   button_title='View All'
                   button_action={ () => { history.push(routes.APPOINTMENTS) }}
                   iconColor={'#1dc2ff'} />
  }

  renderFilters = () => {
    let display_filters = this.props.displayFilters === true ? true : false;
    let current_filter  = this.props.currentFilter || 'UPCOMING';
    let filter_change_action = this.props.onFilterChange ? this.props.onFilterChange : (status) => {  };

    if (!display_filters) {
      return null;
    }

    return <div className='flex-container-column' style={{ alignItems: 'center' }}>
      <div className='flex-container-row' style={{ width: 400, justifyContent: 'space-between', backgroundColor: 'white', padding: 10, marginBottom: 20, borderWidth: 2, borderStyle: 'solid', borderColor: '#e7e7e7', borderRadius: 10 }}>
        <span className='button-clear-blue' onClick={ () => { this.props.onFilterChange('UPCOMING') }} style={{ backgroundColor: current_filter === 'UPCOMING'  ? '#e8f8ff' : '' }}>Upcoming</span>
        <span className='button-clear-blue' onClick={ () => { this.props.onFilterChange('COMPLETED') }} style={{ backgroundColor: current_filter === 'COMPLETED' ? '#e8f8ff' : '' }}>Completed</span>
        <span className='button-clear-blue' onClick={ () => { this.props.onFilterChange('CANCELLED') }} style={{ backgroundColor: current_filter === 'CANCELLED' ? '#e8f8ff' : '' }}>Cancelled</span>
      </div>
    </div>
  }

  render() {
    return this.renderAppointments(this.props.appointmentsIds);
  }

  getParticipantInfo = (appointment) => {
    let consultations_dict = this.props.consultations || {};
    let users_dict         = this.props.users || {};
    let consultation_id    = appointment.consultation_id || '';
    let consultation_info  = consultations_dict[consultation_id] || null;
    let participants       = { provider: '', client: '' }

    if (consultation_info) {
      let provider = users_dict[consultation_info.primary_assignee] || {};
      let client   = users_dict[consultation_info.primary_client] || {};
      participants.provider = StringUtils.displayName(provider);
      participants.client   = StringUtils.displayName(client);
    }

    return participants;
  }

  getConsultation = (appointment) => {
    let consultations_dict = this.props.consultations || {};
    let consultation_id    = appointment.consultation_id || '';
    let consultation_info  = consultations_dict[consultation_id] || null;

    return consultation_info;
  }

}


export default AppointmentsList
